var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Button, ButtonGroup } from '@noom/wax-component-library';
function DefaultButton(props) {
    return React.createElement(Button, Object.assign({ colorScheme: "gray", variant: "outline", size: "md", paddingX: 4 }, props));
}
function PrimaryButton(props) {
    return React.createElement(DefaultButton, Object.assign({}, props, { colorScheme: "primary", variant: "solid" }));
}
function SecondaryButton(props) {
    return React.createElement(DefaultButton, Object.assign({}, props, { colorScheme: "gray", variant: "ghost" }));
}
// legacy
export { PrimaryButton, SecondaryButton, DefaultButton as Button, ButtonGroup };
const LeButton = (_a) => {
    var { variant = '' } = _a, props = __rest(_a, ["variant"]);
    const Component = {
        primary: PrimaryButton,
        secondary: SecondaryButton,
    }[variant] || DefaultButton;
    return React.createElement(Component, Object.assign({}, props));
};
export default LeButton;
//# sourceMappingURL=index.js.map